import { DateTimeQuestion } from "./datetime-question";
import type { QuestionTypeRendererProps } from "./shared";

type TimeQuestionProps = QuestionTypeRendererProps<"time">;

export default function TimeQuestionType(props: TimeQuestionProps) {
  return <DateTimeQuestion {...props} kind="time" />;
}
